<template>
  <v-card>
    <v-card-text>
      {{ props.field.properties?.helpText }}
      <div v-if="imageUrl">
        <h5>Aktuelles Bild</h5>
        <v-img :src="imageUrl" :max-height="300" />
      </div>
      <h5 v-else>Neues Bild hochladen</h5>
      <UploadForm
        :title="props.field.properties.title"
        :upload-url="uploadUrl"
        :extensions="extensions"
        :name="name"
        :multiple="false"
        :auto-upload="true"
        :additional-data="additionalData"
        @input="updatedValue"
      />
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

import { apiClientV2 } from '@/api/ApiClientV2'
import { ImageObject } from '@/apps/brelag/common/models/image'
import UploadForm, { UploadState } from '@/components/common/UploadForm.vue'

import type { SchemaFormKitProps } from './formkit/types'

const store = useStore()
const model = defineModel<string>()
const props = defineProps<SchemaFormKitProps>()
const imageUrl = ref<string>(null)

function updatedValue(value: UploadState[]) {
  if (value.length > 0) {
    const image = value[0]
    if (image.success) {
      model.value = image.response.id
    }
  }
}

onMounted(() => {
  if (!model.value || model.value === '0') {
    return
  }

  let url
  if (
    props.field.properties.modelClass &&
    props.field.properties.modelClass === ImageObject.objectType
  ) {
    apiClientV2.get<ImageObject>(ImageObject, model.value).then((image) => {
      imageUrl.value = image.url
    })
  } else if (props.field.properties.imageUrl) {
    url = props.field.properties.imageUrl.replace('%', model.value)
  }

  if (url && url.length > 0) {
    // The random part at the end is necessary, because otherwise Vue seems to cache the image and does not re-download if it has been changed
    imageUrl.value = `${url}?${Math.random()}`
  }
})

const additionalData = computed(() => {
  // TODO: add means to input title and image meta data
  return {
    title: 'title',
    meta: JSON.stringify({}),
    organisation:
      store.getters['global/organisation'] &&
      store.getters['global/organisation'].id,
  }
})

const uploadUrl = computed(() => {
  return props.field.properties.uploadUrl ?? props.field.properties.uploadUrl
})

const name = computed(() => {
  return props.field.properties.name
})

const extensions = computed(() => {
  if (props.field.properties.extensions) {
    return props.field.properties.extensions
  } else {
    return ['gif', 'jpg', 'jpeg', 'png']
  }
})
</script>

<style lang="scss" scoped>
.image--no-zoom img {
  display: block;
  width: auto;
}
</style>
